import { createSlice } from '@reduxjs/toolkit';
import { Questions } from '../utils/questions-data';

const setQuestions = createSlice({
    name: 'setQuestions',
    initialState: [{ type: 'default' }],
    reducers: {
        choose: (state, action) => {
            return Questions[action.payload];
        },
    },
});

export const { choose } = setQuestions.actions;
export default setQuestions.reducer;
